import { Component } from "react";
import Loader from "../../../../../utils/Loader";
import { ToastContainer } from "react-toastify";
import ExhibitorTopMenu from "../../../../../common_components/exhibitor_module_topmenu";
import { withRouter } from "../../../../../utils/withRouter";
import { connect } from "react-redux";
import { getInternetConnectionMasterList_action, insertUpdateInternetConnectionMaster_action, deleteInternetConnectionMaster_action } from '../../../../../actions/admin_module_action/master_action/manual_form_master_action/internet_connection_master_action'
import { toastError, toastSuccess } from "../../../../../utils/constants";
import Modal from "react-modal";
import ExhibitorHeader from "../../../../../common_components/exhibitor_module_header";
import ExhibitorDrawer from "../../../../../common_components/exhibitor_module_drawer";
import Footer from "../../../../../common_components/Footer";
import HeaderWithLogo from "../../../../../common_components/header_with_logo";
import AdminDrawer from "../../../../../common_components/admin_module_drawer";



class InternetConnectionMasterList extends Component {

    // Initialize Constructor
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
            isOpen: false,
            // currentPage: 1,
            internetConnectionMasterList: [],
            deleteID: '',
        }
        this.getInternetConnectionMasterList = this.getInternetConnectionMasterList.bind(this)
        this.deleteInternetConnectionMaster = this.deleteInternetConnectionMaster.bind(this)
        this.handleAdd = this.handleAdd.bind(this)
        this.deleteInternetConnectionMaster = this.deleteInternetConnectionMaster.bind(this)
        this.onDelete = this.onDelete.bind(this)
    }

    componentDidMount() {
        this.getInternetConnectionMasterList()
    }

    getInternetConnectionMasterList(status) {
        this.setState({ isLoading: true })
        this.props.getInternetConnectionMasterList_action()
            .then((data) => {
                if (data.error != 1) {
                    var contactList = data.data[0]
                    var bankDetailsList = data.data[1]
                    var finalList = []
                    for (var i = 0; i < contactList.length; i++) {
                        for (var j = 0; j < bankDetailsList.length; j++) {
                            if (contactList[i].InternetConnectionContactPersonID == bankDetailsList[j].InternetConnectionContactPersonID) {
                                var mergObj = { ...contactList[i], ...bankDetailsList[j] }
                                finalList.push(mergObj)
                            }
                        }
                    }
                    console.log(finalList)
                    this.setState({ internetConnectionMasterList: finalList })
                    this.setState({ isLoading: false })
                } else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((err) => {
                console.log(err)
            })
    }

    deleteInternetConnectionMaster(id) {
        this.setState({ isLoading: true })
        this.props.deleteInternetConnectionMaster_action(id)
            .then((data) => {
                if (data.error != 1) {
                    console.log(data.data)
                    this.setState({ isLoading: false })
                    toastSuccess("deleted successfully")
                    setTimeout(() => {
                        this.getInternetConnectionMasterList(1)
                    }, 200);
                }
                else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
                this.setState({ isOpen: false })
            })
            .catch((err) => {
                console.log(err)
            })
    }


    // Handle Add 
    handleAdd() {
        this.props.navigate('/internetConnectionMasterAU', { state: { is_add: true } })
    }

    onDelete(id, index, status) {
        const { internetConnectionMasterList } = this.state
        console.log(status, index)
        this.setState({ deleteID: id })
        this.setState({ isOpen: true, })
    }

    render() {
        const { isLoading, isOpen, internetConnectionMasterList } = this.state
        return (
            <>
                {isLoading ? (
                    <Loader></Loader>
                ) : (
                    null
                )}
                <ToastContainer />
                <HeaderWithLogo />
                <>
                    <div className="app-content with-dr-container com-height">
                        <AdminDrawer />
                        <div className="main-container">
                            <div className="row m-0">
                                <div className="breadcrumb-scroll-fixed">
                                    <h6 className="mb-0 p-2 text-white">Internet Connection Master</h6>
                                </div>
                            </div>
                            <div className="admin-top-space p-2 px-0">
                                <div className="row m-0">
                                <div className="table-responsive">
                                    <div
                                        className="card-header p-2"
                                        style={{ paddingLeft: "7px !important" }}
                                    >
                                        <h3 className="card-title" style={{ fontSize: 15 }}>
                                            Agency contact and bank details
                                        </h3>
                                    </div>
                                    <div className="table-responsive ">
                                        <table className="table border text-nowrap text-md-nowrap table-bordered mb-0 mt-1">
                                            <thead>
                                                <tr>
                                                    <th className="text-center">Name</th>
                                                    <th className="text-center">Designation</th>
                                                    <th className="text-center">Telephone</th>
                                                    <th className="text-center">Mobile</th>
                                                    <th className="text-center">Fax</th>
                                                    <th className="text-center">Email</th>
                                                    <th className="text-center">Account Number</th>
                                                    <th className="text-center">Bank Name</th>
                                                    <th className="text-center">Branch Name</th>
                                                    <th className="text-center">Address</th>
                                                    <th className="text-center">RTGS IFSC</th>
                                                    <th style={{ width: '60px' }} className="text-center">Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    internetConnectionMasterList.length > 0 ? (internetConnectionMasterList.map((data, i) => (
                                                        <tr key={data.InternetConnectionContactPersonID}>
                                                            <td className="text-center">{data.Name}</td>
                                                            <td className="text-center">{data.Designation}</td>
                                                            <td className="text-center">{data.Phone}</td>
                                                            <td className="text-center">{data.Mobile}</td>
                                                            <td className="text-center">{data.Fax}</td>
                                                            <td className="text-center">{data.Email}</td>
                                                            <td className="text-center" >{data.AccountNumber}</td>
                                                            <td className="text-center" >{data.BankName}</td>
                                                            <td className="text-center" >{data.Branch}</td>
                                                            <td className="text-center" >{data.Address}</td>
                                                            <td className="text-center" >{data.RTGS_IFSC}</td>
                                                            <td className="text-center">
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-outline-danger btn-sm border-0"
                                                                    onClick={(e) => this.onDelete(data.InternetConnectionContactPersonID, i)}
                                                                >
                                                                    <i className="fa fa-trash action_btn_table" />
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    ))) : <tr><td className="text-center" colSpan={20}>No record found</td></tr>
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                    <div className="text-end mt-2">
                                    <button
                                        type="button"
                                        className="btn btn-aqua"
                                        onClick={() => this.handleAdd()}
                                    >
                                        Add
                                    </button>
                                     </div>
                                </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
                <Modal isOpen={isOpen} onRequestClose={() => this.setState({ isOpen: false })}>
                    <div className="modal-dialog" style={{ marginTop: '20%' }}>
                        <div className="modal-content confirm-logout">
                            <div class="modal-header text-right p-2">
                                <h5 class="modal-title">Do you really want to delete this record?</h5>

                                {/* <button type="button " class="close pop-close" data-dismiss="modal"
                                    onClick={() => this.setState({ isOpen: false })}
                                ><span aria-hidden="true" class="pop-cancel">&times;</span></button> */}
                            </div>
                            {/* <div class="modal-body">
                                <div class="row">
                                </div>
                            </div> */}
                            <div class="modal-footer p-1">
                                <div class="form-group text-right mod-fot">
                                    <button type="button" class="btn btn-del-pop"
                                        onClick={(e) => this.deleteInternetConnectionMaster(this.state.deleteID)}
                                    >Yes</button>
                                    <button type="button" class="btn btn-gray" data-dismiss="modal" style={{ marginLeft: '5px' }}
                                        onClick={() => this.setState({ isOpen: false })}
                                    >No</button>
                                </div>
                            </div>

                        </div>
                    </div>
                </Modal>
                <Footer />
            </>
        )
    }
}

export default withRouter(connect(null, { getInternetConnectionMasterList_action, insertUpdateInternetConnectionMaster_action, deleteInternetConnectionMaster_action })(InternetConnectionMasterList));